/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    Data Table
\*------------------------------------*/
class HeroInfo {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        $('.hero__info__icon').click(function(){
            $('.hero__info__content').toggle();
        });
    }
}

export default HeroInfo;
